module.exports = "/fonts/ebupot-picturemark-l-9ade918c065d4ea4b3d207c7b0cfbe50.svg";